const PropertyResults = {
  $: 'Flex',
  children: (props) => {
    const { template, container, empty, config: { provide, ...config } = {} } = props;
    return {
      $: 'Iterator',
      provide,
      props: {
        container,
        template,
        empty,
        ...config,
      },
    };
  },
};

export default PropertyResults;
